import { FC } from "react"

interface PlayerFilterProps {
  playerName: string
  onClear: () => void
}

export const PlayerFilter: FC<PlayerFilterProps> = ({ playerName, onClear }) => {
  return (
    <div className="mb-3 flex items-center gap-2 px-3 py-2 bg-violet-50 dark:bg-violet-900/20 border border-violet-200 dark:border-violet-800/40 rounded-lg">
      <span className="text-sm text-violet-700 dark:text-violet-300">
        Filtering messages by <strong>{playerName}</strong>
      </span>
      <button
        onClick={onClear}
        className="ml-auto px-2 py-0.5 text-xs bg-violet-600 text-white rounded hover:bg-violet-700 transition-colors"
      >
        Clear filter
      </button>
    </div>
  )
}
